import { frontendEnv } from '@/lib/api/env';
import { ensureTrailingSlash, stripTrailingSlash } from '@/lib/utils';

export const getWorkerUrl = (name: string, path = '', protocol = 'https') =>
    ensureTrailingSlash(
        `${stripTrailingSlash(`${protocol}://${name}${frontendEnv.NEXT_PUBLIC_CLOUDFLARE_WORKER_ENV ? `-${frontendEnv.NEXT_PUBLIC_CLOUDFLARE_WORKER_ENV}` : ''}.${frontendEnv.NEXT_PUBLIC_CLOUDFLARE_BASE}`)}${path}`,
    );
